import React from 'react'
import {
  SEATOW_AUTO_RENEWAL_AGREEMENT_URL,
  SEATOW_INFO_CONTACT_EMAIL,
  SEATOW_PHONE,
  SEATOW_PHONE_DIGITS,
  SEATOW_URL,
} from 'config'

const propTypes = {}

function AutoRenewalContent() {
  return (
    <label className="auto-renewal-agreement-text">
      Your Sea Tow membership will renew automatically each year on your
      expiration date at the then current membership rate, in accordance with
      the{' '}
      <a href={`https://${SEATOW_AUTO_RENEWAL_AGREEMENT_URL}`}>
        Sea Tow Automatic Renewal Program Agreement
      </a>
      . You also may opt out anytime through{' '}
      <a href={`https://${SEATOW_URL}`}>seatow.com</a>, the Sea Tow app, by
      phone at <a href={`tel:${SEATOW_PHONE}`}>{SEATOW_PHONE}</a> (
      {SEATOW_PHONE_DIGITS}) or by emailing{' '}
      <a href={`mailto:${SEATOW_INFO_CONTACT_EMAIL}`}>
        {SEATOW_INFO_CONTACT_EMAIL}
      </a>
      .
    </label>
  )
}

AutoRenewalContent.propTypes = propTypes

export default AutoRenewalContent
